module.exports = __webpack_public_path__ + "static/media/Tupe11.698c73ff.webp";